export const URLAPISUBIDA = 'https://esperanzahispana.com.co/notis/subirimg.php'

export const URLAPISUBIDAVIDEO = 'https://esperanzahispana.com.co/notis/subirvideo.php'
export const URLCARPETADESTINO = 'https://esperanzahispana.com.co/notis/'

export const URLAPISUBIDAPDF = 'https://esperanzahispana.com.co/notis/subirpdf.php'

export const URLCARPETADESTINOPDF = 'https://esperanzahispana.com.co/notis/'